const React = require("react");
const noop = require("mn-utils/noop");

const withState = require('../../../../../../utils/withState');
const WrapperWithLoading = require('../../../../../dumb/WrapperWithLoading');

const DashboardBlockTitle = require("../DashboardBlockTitle");
const DashboardBlockField = require("../DashboardBlockField");
const DashboardBlock = require("../DashboardBlock");

const TimeFilters = require("./components/TimeFilters");
const IntervalFilter = require("../../../../../dumb/IntervalFilter");

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    data: {},
    loading: true
  };

  const getParams = () => {
    const emitter = self.props.timePeriodEmitter || {getValue: noop};
    const value = emitter.getValue();

    const {
      getDateRange,
    } = IntervalFilter;

    const result = {};

    const interval = value === 'all' ? 'all-time' : value;

    const {from, to} = getDateRange({interval});

    result['from'] = Math.floor(from / 1000);
    result['to'] = Math.floor(to / 1000);

    return result;
  }

  const getData = () => {
    setState({loading: true});

    const req = self.props.request;

    if (!req) {
      setState({loading: false});
      return;
    }

    req(getParams()).then((data) => setState({data, loading: false}));
  };

  const onChange = (id) => {
    const emitter = self.props.timePeriodEmitter || {emit: noop};
    emitter.emit(id);
    setTimeout(getData, 100);
  }

  onMount(getData);

  return (state, props) => {
    const {loading, data = {}} = state;
    const {title, propValue, handleValue, timePeriodEmitter} = props;

    return (
      <WrapperWithLoading loading={loading}>
        <DashboardBlock disablePaddings>
          <div className="layoutRow jcSB aiC pt8 pr8 pb11 pl21">
            <DashboardBlockTitle>
              {title}
            </DashboardBlockTitle>
            <DashboardBlockField
              className="(wmin122|h36|jcFE|ph13|f16|fw7)>.ref-field__block"
            >
              {(handleValue ? handleValue(data) : data[propValue]) || 0}
            </DashboardBlockField>
          </div>
          <TimeFilters value={timePeriodEmitter.getValue()} onChange={onChange} />
        </DashboardBlock>
      </WrapperWithLoading>
    );
  }
})
